// Help: how TUNE Analytics and the TUNE MFD work together, in a few questions, and how to write to TUNE.
import { useAuth } from '../../auth';
import { Page } from '../../shell/Page';
import { Card, Disclosure } from '../../ui';
import s from './Help.module.css';

export function Help() {
  const signedIn = useAuth().session('owners') !== null;
  return (
    <Page
      title="Help"
      root={signedIn}
      subtitle="How TUNE Analytics and your TUNE MFD work together, and how to reach TUNE."
    >
      <section className={s.questions} aria-labelledby="questions">
        <h2 id="questions" className={s.sectionTitle}>
          Questions
        </h2>
        <Disclosure summary="Signing in an MFD">
          <ol className={s.list}>
            <li>On the MFD, open Settings, then TUNE account. It shows a QR code, and the code in letters.</li>
            <li>Scan the QR code with your phone's camera, or open Sign in an MFD here and type the code.</li>
            <li>Sign in, then choose the car the MFD is in.</li>
          </ol>
          <p>A code works for ten minutes. For a new one, open TUNE account on the MFD again.</p>
        </Disclosure>
        <Disclosure summary="Datalogs, trips and track days">
          <p>
            The MFD records a datalog when you start one. While it's signed in, it sends datalogs, trips and track days
            to your account when the car has stopped and it has a connection.
          </p>
          <p>They're kept for 12 months. Datalogs open in the Analyser, from Telemetry or the car's Recordings.</p>
        </Disclosure>
        <Disclosure summary="Dashboards and configs">
          <p>
            Your library holds your own dashboards and configs. Your MFDs get them by themselves, at their next sync,
            with TUNE's from its catalogue and those of the groups you're in.
          </p>
          <p>Configs, which tell a CANBOX what your car sends, can be made in Create.</p>
        </Disclosure>
        <Disclosure summary="A car's settings">
          <p>
            A car's settings are the same on its MFD and here: change them in either. If both change one before they
            sync, the page says so, and you choose which to keep.
          </p>
        </Disclosure>
        <Disclosure summary="Diagnostics">
          <p>
            When TUNE asks, send diagnostics from the MFD's Log page. The MFD shows a reference, such as D-7F3K9B: put
            it in your email, so TUNE finds them.
          </p>
        </Disclosure>
        <Disclosure summary="What TUNE keeps">
          <ul className={s.list}>
            <li>Your email and name, and the devices signed in to your account.</li>
            <li>Your cars: their settings, connections, trip computer and service history.</li>
            <li>Datalogs, trips and track days for 12 months. Datalogs show where the car went.</li>
            <li>Your dashboards and configs, and who you shared them with.</li>
            <li>Diagnostics only when you send them, for 90 days.</li>
            <li>Never your password: Amazon's sign-in service keeps it, scrambled.</li>
          </ul>
        </Disclosure>
      </section>
      <Card title="Write to TUNE">
        <a className={s.mail} href="mailto:contact@tunemfd.com">
          contact@tunemfd.com
        </a>
        <p>It helps to say:</p>
        <ul className={s.list}>
          <li>the email you sign in with;</li>
          <li>which car, and which MFD;</li>
          <li>what you did, and what happened;</li>
          <li>a diagnostics reference, if the MFD gave you one.</li>
        </ul>
      </Card>
    </Page>
  );
}
